import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    on: translate({ id: 'global.on' }),
    off: translate({ id: 'global.off' }),
    vehicles: translate({ id: 'global.vehicles' }),
    notToday: translate({ id: 'globalStyles.vehicles.notToday' }),
    noVehicles: translate({ id: 'globalStyles.vehicles.noVehicles' }),
    onWithLabel: translate({ id: 'globalStyles.vehicles.onWithLabel' }),
  }))

  return api
}
